export default __webpack_public_path__ + "static/media/5、首页电解质水.4b442143.jpg";